import Navigation from "../../common/components/Navigation/Navigation";
import { Outlet, useLocation } from "react-router-dom";
import {
  getCurrentElements,
  getSelectedProjectGroup,
} from "../../features/projectGroups/state/projectGroupsSlice";
import { useTranslation } from "react-i18next";
import AddTeamModal from "../../features/team/components/AddTeamModal";
import ParticipantCsv from "../../features/team/components/ParticipantFromCsvModal";
import { useAppDispatch, useAppSelector } from "src/common/state/hooks";
import { fetchFilteredMedias, resetMediaSearch } from "src/features/gallery/state/gallerySlice";
import { jwtSelector } from "src/common/state/selectors/authSelector";
import { openPreviewInNewTab } from "src/common/util/openPreviewInNewTab";
import { setAlert } from "src/features/alert/state/alertsSlice";
import { trackEvent } from "src/trackEvent";
import { PROJECT_GROUP_MEDIAS_COMPONENT_ID } from "./projectGroupMediasComponentId";

const ProjectGroupEdit = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const path = location.pathname.split("/");
  const lastUrlElement = path[path.length - 1];

  const jwt = useAppSelector(jwtSelector);
  const selectedProjectGroup = useAppSelector(getSelectedProjectGroup);
  const selectedCurrentElements = useAppSelector(getCurrentElements);

  const isProjectGroupLoaded = Boolean(selectedProjectGroup.id);
  const publishTabShouldBeVisible = selectedCurrentElements && selectedCurrentElements.length > 0;
  const isAnonymousCourse = isProjectGroupLoaded && selectedProjectGroup.auth_type === "none";

  const tabs = [
    { title: t("pages.projectGroup.tabs.list"), urlEndPoint: "list" },
    {
      title: t("general.preview"),
      urlEndPoint: "preview",
      preventNavigation: true,
      onClick: async () => {
        if (selectedProjectGroup.id && jwt) {
          trackEvent("preview-open");
          const result = await openPreviewInNewTab({
            projectGroupId: selectedProjectGroup.id,
            jwt,
            name: selectedProjectGroup.name,
          });
          if (!result.success) {
            dispatch(
              setAlert({
                msg: t("alerts.previewError"),
                type: "warning",
              }),
            );
          }
        }
      },
    },
    {
      title: t("general.medias"),
      urlEndPoint: "medias",
      onClick: () => {
        dispatch(resetMediaSearch({ resetEverything: true }));
        void dispatch(
          fetchFilteredMedias({
            start: 0,
            limit: 20,
            projectGroupId: selectedProjectGroup.id,
            componentId: PROJECT_GROUP_MEDIAS_COMPONENT_ID,
          }),
        );
      },
    },
    { title: t("pages.projectGroup.tabs.team"), urlEndPoint: "team" },
    {
      title: t("pages.projectGroup.tabs.learners"),
      urlEndPoint: "learners",
      disabled: isAnonymousCourse,
      disabledTooltip: isAnonymousCourse ? t("pages.statistics.anonymousCourse") : undefined,
    },
    {
      title: t("pages.projectGroup.tabs.publish"),
      urlEndPoint: "publish",
      hidden: !publishTabShouldBeVisible,
    },
    { title: t("general.information"), urlEndPoint: "information" },
  ];

  return (
    <>
      <Navigation
        title={selectedProjectGroup.name}
        tabs={tabs}
        isProjectGroupView
        showGoBackButton
        backDepth={lastUrlElement === "new" ? 1 : 2}
      />
      <Outlet />
      <AddTeamModal />
      <ParticipantCsv />
    </>
  );
};

export default ProjectGroupEdit;
